import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/admins";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function update(id, { roleId, teacherId } = {}) {
  return axios.patch(`${BASE}/${id}`, { roleId, teacherId });
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}

export function getPermissions() {
  return axios.get(`${BASE}/permissions`);
}
